import { z } from "zod";

import { useFormWithZod } from "@/hooks/useFormWithZod";

const schema = () =>
  z.object({
    id: z.string().optional(),
    name: z
      .string({ required_error: "Role name is required" })
      .min(1, "Role name is required"),
    client_profile_permissions: z.array(z.string()).optional().nullable(),
    packets_forms_building_permissions: z
      .array(z.string())
      .optional()
      .nullable(),
    form_packet_submission_permissions: z
      .array(z.string())
      .optional()
      .nullable(),
    report_data: z.array(z.string()).optional().nullable(),
    settings: z.array(z.string()).optional().nullable(),
  });

export type RoleFormModel = z.infer<ReturnType<typeof schema>>;

export const useRoleForm = () => {
  const roleTabFormTypeSchema = schema();
  const { form, rule } = useFormWithZod(roleTabFormTypeSchema);
  return { form, rule, schema: roleTabFormTypeSchema };
};
